import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-white" data-id="element-169" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-170" data-mp="3b146nhllnt7f">
        <h2 id="testimonios" className="font-display text-xl uppercase leading-tight text-brand-carbon sm:text-3xl" data-id="element-171" data-mp="3ayqb77n0cezc">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-brand-muted" data-id="element-172" data-mp="2x0temb8k08ko">
          De no saber por dónde comenzar a comprender cómo funciona una
          automatización.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-173" data-mp="v9gahoeeu4po">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-brand-steel bg-brand-steel/50 p-3 text-left" data-id="element-174" data-mp="qac393b1qh1z" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-175" data-mp="m5b3blltfogr">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-176" data-mp="79ld1b9lkp68" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1.5 text-[0.8rem] font-medium leading-snug text-brand-carbon" data-id="element-177" data-mp="zyivbedt6lyz">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto border-t border-brand-steel pt-2" data-id="element-178" data-mp="q5lcf74wmuzu">
                <p className="text-[0.75rem] font-extrabold uppercase text-brand-blue" data-id="element-179" data-mp="v57mx8tclx4y">
                  {t.author}
                </p>
                <p className="text-[0.68rem] leading-snug text-brand-muted" data-id="element-180" data-mp="1iuiimbvud1c8">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-lg bg-brand-navy p-3" data-id="element-181" data-mp="1xgpl3evlww9n">
            <CtaButton href={OFFER_ANCHOR} data-id="element-182" data-mp="1ogjb42z4aef8">
              🚀 Sí, quiero comenzar ahora
            </CtaButton>
            <p className="mt-2 text-[0.68rem] font-semibold text-white/85" data-id="element-183" data-mp="1jh6dqoamdoye">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}